<script lang="tsx">
import { computed, defineComponent } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { createNamespace } from '@bd/vue3-utils'
import { isAuth } from '@/directive/permission'
import { authLinkProps } from './props'

const [name] = createNamespace('AuthLink')

export default defineComponent({
  name,
  props: authLinkProps,
  setup(props, { attrs, slots }) {
    const router = useRouter()

    const isValidate = computed(() => props.name && isAuth(props.permission) && router.hasRoute(props.name))
    const routeConfig = computed(() => ({ name: props.name, ...props.to }))

    return () => {
      const children = slots?.default?.()

      if (!isValidate.value) {
        return <span {...attrs}>{children}</span>
      }

      if (props.blank) {
        const { href } = router.resolve(routeConfig.value)
        return (
          <a href={href} target='_blank' rel='noopener noreferrer' {...attrs}>
            {children}
          </a>
        )
      }

      return (
        <RouterLink to={routeConfig.value} {...attrs}>
          {children}
        </RouterLink>
      )
    }
  }
})
</script>
